export const getTextAssetRecommendationsStyles = () => ({
  textAssetRecommendationsContent: {
    '& .collapsible-content': {
      '& .suggested-item-add': {
        '& .ms-Button-label': {
          height: '30px',
          lineHeight: '30px',
        },
      },
    },
  },
  textAssetRecommendationsPanel: {
    '& .ms-Panel-content': {
      paddingTop: '20px',
      '& .selectable-suggested-item-toggle': {
        height: 'auto',
        padding: '6px 0',
        '& .ms-Button-label': {
          lineHeight: '120%',
        },
      },
    },
  },
});
